import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme";
import { AuthProvider, useAuth } from "./pages/login/loginPage/AuthContext";
import { AuthProvider as AuthChauffeurProvider } from "./pages/zotSuivis/espaceChauffeur/auth"; // Import du provider chauffeur
import App from "./App";
import { Login } from "./pages/login/loginPage/login";
import { LoginChauffeur } from "./pages/zotSuivis/espaceChauffeur/login";
import { ProtectedDriverRoute } from "./pages/zotSuivis/espaceChauffeur/protectedDriverRoute";
import { EspaceChauffeur } from "./pages/zotSuivis/espaceChauffeur/espaceChauffeurs";
import { EspaceEffectue } from "./pages/zotSuivis/espaceChauffeur/Effectue/espaceEffectue";
import {Profile} from "./pages/zotSuivis/espaceChauffeur/profile/espaceProfile";
const ProtectedRoute = ({ element: Element, ...rest }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  return isAuthenticated ? <Element {...rest} /> : <Navigate to="/login" />;
};

const AppRouter = () => {
  const { login } = useAuth();

  useEffect(() => {
    const eventChannel = new BroadcastChannel("auth");

    const handleAuthEvent = (event) => {
      if (event.data === "logout") {
        localStorage.removeItem("isAuthenticated");
        login(null);
        window.location.href = "/login";
      }
    };

    eventChannel.addEventListener("message", handleAuthEvent);

    return () => {
      eventChannel.removeEventListener("message", handleAuthEvent);
    };
  }, [login]);

  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <AuthChauffeurProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={<ProtectedRoute element={App} />} />

            <Route path="/chauffeur/login" element={<LoginChauffeur />} />

       
            <Route
              path="/chauffeur/courses"
              element={
                <ProtectedDriverRoute>
                  <EspaceChauffeur />
                </ProtectedDriverRoute>
              }
            />

            <Route
              path="/chauffeur/effectue"
              element={
                <ProtectedDriverRoute>
                  <EspaceEffectue />
                </ProtectedDriverRoute>
              }
            />

            <Route
              path="/chauffeur/compte"
              element={
                <ProtectedDriverRoute>
                 <Profile />
                </ProtectedDriverRoute>
              }
            />

          </Routes>
        </AuthChauffeurProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default AppRouter;